import React, { useState } from "react";
import SearchableSelect from "../../../core/common/SearchableSelect";
import handleClearError from "../../../core/methods/handleClearError";
import { ErrorType } from "../../../types/common-type";
import {
  clientOptions,
  programOption,
  sbuOptions,
} from "../../../core/data/js/common-data";
import { ColumnsType } from "antd/es/table";
import Datatable from "../../../core/common/dataTable";

const ReportsMaster = () => {
  const [itemList, setItemList] = useState([
    { sno: 1, email: "test@techmahindra.com" },
  ]);

  const [errors, setErrors] = useState<ErrorType>({});
  const [filterData, setFilterData] = useState({
    client_company: "",
    program: "",
    geo: "",
    sbu_project: "",
    dept_loc: "",
    package: "",
  });

  // handleFieldDataChange
  const handleFieldDataChange = (
    name: string,
    value: string,
    label: string,
  ) => {
    setFilterData((prev: any) => ({
      ...prev,
      [name]: prev[name] == value ? "" : value,
      ...(name === "program" && { geo: "india" }),
      ...(name === "sbu_project" && { dept_loc: "gurugram" }),
    }));
    handleClearError(setErrors, name);

    if (name === "program") handleClearError(setErrors, "geo");
    if (name === "sbu_project") handleClearError(setErrors, "dept_loc");
  };

  // columns
  const columns: ColumnsType<any> = [
   {
      title: "Sr. No.",
      key: "srNo",
      width: 80,
      align: "center",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      render: (_: any, record: any) => (
        <button
          className="btn btn-danger btn-sm"
          // onClick={() => handleRemove(record)}
        >
          Remove
        </button>
      ),
    },
  ];

  // remove handler
  // const handleRemove = (record: any) => {
  //   setDataSource((prev) => prev.filter((item) => item.sno !== record.sno));
  // };

  return (
    <>
      <div className="card mt-3 border-0 shadow-sm">
        <div className="card-body">
          {/* Report Type */}
          <div className="d-flex align-items-center gap-4 mb-3">
            <label className="fw-medium mb-0">
              How would you like to receive the report
            </label>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="reportType"
                id="yes"
                defaultChecked
              />
              <label className="form-check-label" htmlFor="yes">
                Yes (Online+Email)
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="reportType"
                id="online"
              />
              <label className="form-check-label" htmlFor="online">
                Online
              </label>
            </div>
          </div>

          {/* Note */}
          <p className="mb-4">
            <strong>Please note:</strong> To change report notification settings
            at the program or SBU level for any client, please contact the IT
            Team.
          </p>

          {/* Dropdowns */}
          <div className="row mb- 3">
            <div className={`col-6 col-md-4 mb-0 `}>
              <SearchableSelect
                label="Client Account"
                name="client_company"
                value={filterData?.client_company}
                options={clientOptions}
                onChange={handleFieldDataChange}
                hasRowGrid={false}
                error={errors?.client_company}
                required
              />
            </div>
            <div className={`col-6 col-md-4 mb-0 `}>
              <SearchableSelect
                label="Program Assignment"
                name="program"
                value={filterData?.program}
                options={programOption}
                onChange={handleFieldDataChange}
                hasRowGrid={false}
                error={errors?.program}
                required
                disabled
                // readOnly={!filterData.client_company}
              />
            </div>
            <div className={`col-6 col-md-4 mb-0 `}>
              <SearchableSelect
                label="Business Unit / Project"
                name="sbu_project"
                value={filterData?.sbu_project}
                options={sbuOptions}
                onChange={handleFieldDataChange}
                hasRowGrid={false}
                error={errors?.sbu_project}
                // readOnly={!filterData.geo}
                required
                disabled
              />
            </div>
          </div>

          {/* Email Input */}
          <div className="row align-items-end mb-4">
            <div className="col-md-5">
              <label className="form-label">Add recipient email *</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email Username"
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Domain</label>
              <select className="form-select">
                <option>@</option>
                <option>@techmahindra.com</option>
                <option>@gmail.com</option>
              </select>
            </div>

            <div className="col-md-2">
              <button className="btn btn-success">Add</button>
            </div>
          </div>

          {/* Table */}
          <Datatable
            dataSource={itemList}
            columns={columns}
            hideSizeChanger={true}
          />

          {/* Footer */}
          <div className="mt-4 d-flex justify-content-between align-items-center">
            <p className="mb-0">
              <strong>Note:</strong> Changes will reflect only after clicking on
              submit.
            </p>

            <button type="button" className="btn btn-success px-4">
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportsMaster;
